import { render, staticRenderFns } from "./UserFormScreen.vue?vue&type=template&id=37bc6b16&"
import script from "./UserFormScreen.vue?vue&type=script&lang=ts&"
export * from "./UserFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports